export default "__VITE_ASSET__4fa9a99f__"